module.exports = __webpack_public_path__ + "static/media/feature_1.bb9e60be.png";